import { compose, filter, pathOr } from 'ramda'
import { gql } from '@apollo/client'
import React from 'react'

import { serviceOrdersClient } from '../../../utils/apollo/api'
import { usePromiseQuery } from '../../../utils/apollo/_helpers/promiseQuery'
import Select from '../../../packages/kiti/components/form/Select'

const QUERY = gql`
  query Statuses($search: String, $page: Int) {
    statuses(search: $search, page: $page, sort: { field: ID, type: ASC }, limit: 999999) {
      id
      name
      label
    }
  }
`

export const MANUAL_STATUSES = ['approved', 'canceled', 'disapproved', 'pause']

const useStatusesLoader = ({ manualStatusOnly }) => {
  const query = usePromiseQuery(QUERY, { client: serviceOrdersClient })

  return (search, page = 1) => {
    return query({ search, page })?.then(
      compose(
        filter(item => !manualStatusOnly || MANUAL_STATUSES.includes(item.name)),
        pathOr([], ['data', 'statuses'])
      )
    )
  }
}

const ServiceOrderStatusSelect = ({ ...props }) => {
  const getOptions = useStatusesLoader(props)

  return <Select options={getOptions} labelField="label" {...props} />
}

export default ServiceOrderStatusSelect
